import React from 'react';

export const OrangeFilledTick = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(2.4 2.4)" stroke="#FF7000" strokeWidth="1.5" fill="none" fillRule="evenodd">
        <circle cx="9.6" cy="9.6" r="8.85" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.6 4.8v4.8L12 12" />
      </g>
    </svg>
  );
};

export default OrangeFilledTick;
